module.exports = __webpack_public_path__ + "static/start-up-8f6eec36d9349ac929e276953781bd46.jpg";